module.exports = __webpack_public_path__ + "img/idea-score.9330e7b4.svg";